import { useTranslations } from "@zapier/i18n";
import { Select, SelectItem } from "@zapier/design-system";
import { usePageSize } from "../../../../context/PageSizeContext";
import styles from "./Pagination.module.css";
import { Key } from "react";

export enum PageSize {
  TwentyFive = 25,
  Fifty = 50,
  OneHundred = 100,
}

export function PaginationSelect() {
  const t = useTranslations("pagination-select");

  const { size, setSize } = usePageSize();

  const onSetSize = (value: Key | null) => {
    if (setSize && value) {
      setSize({ size: Number(value) });
    }
  };

  return (
    <Select
      aria-label={t("accessibility.select-page-size")}
      label={t("accessibility.select-page-size")}
      isLabelHidden={true}
      placeholder={t("placeholders.select-page-size")}
      onChange={onSetSize}
      selectedKey={size}
    >
      <SelectItem textValue="25" value={PageSize.TwentyFive}>
        {t.rich("labels.per-page", {
          count: PageSize.TwentyFive,
          span: (chunks) => <span className={styles.perPage}>{chunks}</span>,
        })}
      </SelectItem>
      <SelectItem textValue="50" value={PageSize.Fifty}>
        {t.rich("labels.per-page", {
          count: PageSize.Fifty,
          span: (chunks) => <span className={styles.perPage}>{chunks}</span>,
        })}
      </SelectItem>
      <SelectItem textValue="100" value={PageSize.OneHundred}>
        {t.rich("labels.per-page", {
          count: PageSize.OneHundred,
          span: (chunks) => <span className={styles.perPage}>{chunks}</span>,
        })}
      </SelectItem>
    </Select>
  );
}
